import { Panel, Row, Col, FlexboxGrid, Divider, Stack } from 'rsuite';
import { BudgetSettings } from './BudgetSettings';
import { ComponentFactory } from '../../Components/ComponentFactory';
import { useAppSelector } from '../../store/hooks';
import { selectConfigState, selectContentState } from '../calculator/calculatorSlice';
import { isComboPON, isGPON, isXGSPON } from '../../tools';
import { Fragment } from 'react';
import { ComponentTypes } from '../../Components/ComponentFactory/types';
import { BudgetMethods } from './BudgetMethods';

import deviceOneImg from '../../images/device_1.png'
import deviceTwoImg from '../../images/device_2.png'

import './styles.scss'
import { MdArrowForward } from 'react-icons/md';

const deviceOneImgSettings = {
    type: ComponentTypes.IMAGE,
    dummy: true,
    id: "device_one",
    url: deviceOneImg,
    name: "device_one"
}
const deviceTwoImgSettings = {
    type: ComponentTypes.IMAGE,
    dummy: true,
    id: "device_two",
    url: deviceTwoImg,
    name: "device_two"
}
const arrowImgSettings = {
    type: ComponentTypes.ICON,
    dummy: true,
    id: "arrow_img",
    icons: [MdArrowForward],
    width: 50,
    name: "device_one"
}

const DownlinkBudgetCalcHeader = () => {

    return <Stack justifyContent="space-between">
        <h4>Downlink Budget Calculator</h4>
        <Stack>
            <ComponentFactory component={deviceOneImgSettings} />
            <ComponentFactory component={arrowImgSettings} />
            <ComponentFactory component={deviceTwoImgSettings} />
        </Stack>
    </Stack>
}

const UplinkBudgetCalcHeader = () => {
    return <Stack justifyContent="space-between">
        <h4>Uplink Budget Calculator</h4>
        <Stack>
            <ComponentFactory component={deviceTwoImgSettings} />
            <ComponentFactory component={arrowImgSettings} />
            <ComponentFactory component={deviceOneImgSettings} />
        </Stack>
    </Stack>
}


const Budget = () => {
    const configState = useAppSelector(selectConfigState);
    const contentState = useAppSelector(selectContentState);
    const gpon = (row: string) => isGPON() && row === "gpon"
    const xgspon = (row: string) => isXGSPON() && row === "xgspon"
    const isImage = (row: string) => row === "images"
    return (
        <Row className="budget-content-row">
            <Col xs={24} className="budget-content-col">
                <Panel bordered header={<DownlinkBudgetCalcHeader />} className="content-panels">
                    {
                        Object.keys(BudgetSettings.downlink).map((row: any) => {
                            return <FlexboxGrid className="budget-row" justify="space-between" align="middle" key={row}>
                                {
                                    BudgetSettings.downlink[row].map((column: any, i: number) => {
                                        const visibleCond = gpon(row) || xgspon(row) || isComboPON() || isImage(row)
                                        const isVisible = BudgetMethods(column.id)?.isVisible ? (BudgetMethods(column.id)?.isVisible() && visibleCond) : visibleCond
                                        if (isVisible) {
                                            return <FlexboxGrid.Item colspan={2} key={i}>
                                                <ComponentFactory
                                                    component={column}
                                                    methods={BudgetMethods}
                                                    allState={configState}
                                                    componentState={!column.dummy && contentState.downlink[row][column.id]}
                                                />
                                            </FlexboxGrid.Item>
                                        } else {
                                            return <Fragment key={i} />
                                        }
                                    })
                                }

                            </FlexboxGrid>
                        })
                    }
                </Panel>
            </Col>
            <Col xs={24} className="budget-content-divider">
                <Divider />
            </Col>
            <Col xs={24} className="budget-content-col">
                <Panel bordered header={<UplinkBudgetCalcHeader />} className="content-panels">
                    {
                        Object.keys(BudgetSettings.uplink).map((row: any) => {
                            return <FlexboxGrid className="budget-row" justify="space-between" align="middle" key={row}>
                                {
                                    BudgetSettings.uplink[row].map((column: any, i: number) => {
                                        const visibleCond = gpon(row) || xgspon(row) || isComboPON() || isImage(row)
                                        const isVisible = BudgetMethods(column.id)?.isVisible ? (BudgetMethods(column.id)?.isVisible() && visibleCond) : visibleCond
                                        if (isVisible) {
                                            return <FlexboxGrid.Item colspan={2} key={i}>
                                                <ComponentFactory
                                                    component={column}
                                                    methods={BudgetMethods}
                                                    allState={configState}
                                                    componentState={!column.dummy && contentState.uplink[row][column.id]}
                                                />
                                            </FlexboxGrid.Item>
                                        } else {
                                            return <Fragment key={i} />
                                        }

                                    })
                                }

                            </FlexboxGrid>
                        })
                    }
                </Panel>
            </Col>
        </Row>
    )
}


export default Budget;